import Head from "next/head";
import { FunctionComponent } from "react";
import localization from "../localization";

interface CanonicalHeadProps {
  region: string;
  lang: string;
  slug?: string;
}

export const CanonicalHead: FunctionComponent<CanonicalHeadProps> = ({
  region: mainRegion,
  lang: mainLang,
  slug,
}) => {
  // add leading slash to prop, remove leading slash if already present
  // or no slash if no slug provided
  const sanitizedSlug = slug ? `/${slug.replace(/^\//, "")}` : "";
  const domain = "https://bluebottlecoffee.com";

  return (
    <Head>
      <link
        rel="canonical"
        href={`${domain}/${mainRegion}/${mainLang}${sanitizedSlug}`}
      />
      {localization.regionsAndLangs().map(({ region, lang }) => (
        <link
          rel="alternate"
          href={`${domain}/${region}/${lang}${sanitizedSlug}`}
          hrefLang={localization.getISO6391(lang)}
        />
      ))}
    </Head>
  );
};

CanonicalHead.defaultProps = {
  slug: undefined,
};
